import useApiHook from '../../../../hooks/api/useApiHook';
import { useCallback } from 'react';

export const useGetContract = () => {
  const { get, data, error, loading } = useApiHook(true);

  const getContract = useCallback(async (id) => {
    const url = `/contracts/${id}`;
    await get(url);
  }, [get]);

  return { getContract, data, error, loading };
};

export const usePutContract = () => {
  const { put, data, error, loading } = useApiHook(true);

  const putContract = useCallback(async (id, body) => {
    const url = `/contracts/${id}`;
    await put(url, body);
  }, [put]);

  return { putContract, data, error, loading };
};

export const usePostContract = () => {
  const { post, data, error, loading } = useApiHook(true);

  const postContract = useCallback(async (body) => {
    const url = `/contracts`;
    await post(url, body);
  }, [post]);

  return { postContract, data, error, loading };
};

export const useGetCustomerEnum = () => {
  const { get, data, error, loading } = useApiHook(true);

  const getCustomerEnum = useCallback(async () => {
    const url = `/enums/customers`;
    await get(url);
  }, [get]);

  return { getCustomerEnum, data, error, loading };
};


export const useSetContractState = () => {
  const { post, data, error, loading } = useApiHook(true);

  const postContractState = useCallback(async (id, action) => {
    const url = `/contracts/${id}/${action}`;
    await post(url);
  }, [post]);

  return { postContractState, data, error, loading };
};
